import React from "react";

function MasterCardIcon() {
  return (
    <svg width="30" height="21" viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.5 0.333008H2.5C1.11929 0.333008 0 1.4523 0 2.83301V17.833C0 19.2137 1.11929 20.333 2.5 20.333H27.5C28.8807 20.333 30 19.2137 30 17.833V2.83301C30 1.4523 28.8807 0.333008 27.5 0.333008Z"
        fill="black"
      />
      <path
        d="M11.25 16.583C14.7018 16.583 17.5 13.7848 17.5 10.333C17.5 6.88123 14.7018 4.08301 11.25 4.08301C7.79822 4.08301 5 6.88123 5 10.333C5 13.7848 7.79822 16.583 11.25 16.583Z"
        fill="#EB001B"
      />
      <path
        d="M18.75 16.583C22.2018 16.583 25 13.7848 25 10.333C25 6.88123 22.2018 4.08301 18.75 4.08301C15.2982 4.08301 12.5 6.88123 12.5 10.333C12.5 13.7848 15.2982 16.583 18.75 16.583Z"
        fill="#F79E1B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 5.33301C16.5181 6.47327 17.5 8.28869 17.5 10.3335C17.5 12.3782 16.5181 14.1937 15 15.3339C13.4819 14.1937 12.5 12.3782 12.5 10.3335C12.5 8.28869 13.4819 6.47327 15 5.33301Z"
        fill="#FF5F00"
      />
    </svg>
  );
}

export default MasterCardIcon;
